// extracted by mini-css-extract-plugin
export default {"headerWrapper":"o6bAj56gTgmvUzRS2EMn","footerWrapper":"ZBjX2jXE5DesoqGwYmHV","description":"hah73PReRhYehwYSMsew"};